import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-License-Identifier: AGPL-3.0-only
import { AlertTriangle, CheckCircle2, Info, XCircle } from 'lucide-react';
import { cn } from '../../lib/cn.js';
import { toneMixBorderClasses } from '../../lib/tones.js';
const toneClasses = {
    info: 'bg-info-soft [&_[data-part=alert-icon]]:text-info',
    pos: 'bg-pos-soft [&_[data-part=alert-icon]]:text-pos',
    warn: 'bg-warn-soft [&_[data-part=alert-icon]]:text-warn',
    danger: 'bg-danger-soft [&_[data-part=alert-icon]]:text-danger',
};
const defaultIcons = {
    info: _jsx(Info, {}),
    pos: _jsx(CheckCircle2, {}),
    warn: _jsx(AlertTriangle, {}),
    danger: _jsx(XCircle, {}),
};
/**
 * Alert / Callout — tone-soft background + `color-mix` tone border, icon +
 * title + body + optional CTA; tones info/pos/warn/danger
 * (research/design-system.md Tier 3).
 */
export function Alert({ tone = 'info', icon, title, body, action, className, children, ...props }) {
    return (_jsxs("div", { "data-tone": tone, className: cn('flex items-start gap-3 rounded-lg border p-3.5', toneClasses[tone], toneMixBorderClasses[tone], className), ...props, children: [_jsx("span", { "data-part": "alert-icon", "aria-hidden": "true", className: "mt-px shrink-0 [&_svg]:size-4 [&_svg]:stroke-2", children: icon ?? defaultIcons[tone] }), _jsxs("div", { className: "min-w-0 flex-1", children: [_jsx("div", { className: "text-body font-bold leading-snug text-fg", children: title }), body === undefined && children === undefined ? null : (_jsx("div", { className: "mt-0.5 text-body-sm text-fg-muted", children: body ?? children })), action === undefined || action === null ? null : _jsx("div", { className: "mt-2", children: action })] })] }));
}
//# sourceMappingURL=Alert.js.map